export default "__VITE_ASSET__DYzM3ERU__"